import React from 'react';
import {FaQuestionCircle} from "react-icons/fa";

const CircleButton = (props) => {
    return <span onClick={props.onClick} style={props.style} id={props.id}>
        <FaQuestionCircle style={{color: "yellow"}} size={24}/>
    </span>
}

export default CircleButton;